import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularInfoWarning: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_info-warning"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="info-warning icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M10.0016 -0.00195312C15.5253 -0.00195312 20.0031 4.47589 20.0031 9.9996C20.0031 15.5233 15.5253 20.0011 10.0016 20.0011C4.47785 20.0011 0 15.5233 0 9.9996C0 4.47589 4.47785 -0.00195312 10.0016 -0.00195312ZM10.0016 1.49805C5.30627 1.49805 1.5 5.30432 1.5 9.9996C1.5 14.6949 5.30627 18.5011 10.0016 18.5011C14.6968 18.5011 18.5031 14.6949 18.5031 9.9996C18.5031 5.30432 14.6968 1.49805 10.0016 1.49805ZM9.99791 8.49863C10.3776 8.49838 10.6916 8.78033 10.7415 9.14637L10.7484 9.24814L10.752 14.7497C10.7523 15.1639 10.4167 15.5 10.0025 15.5002C9.62279 15.5005 9.30881 15.2185 9.25891 14.8525L9.252 14.7507L9.2484 9.24912C9.24813 8.83491 9.58369 8.4989 9.99791 8.49863ZM10.002 5.00086C10.5535 5.00086 11.0007 5.44798 11.0007 5.99953C11.0007 6.55107 10.5535 6.99819 10.002 6.99819C9.45045 6.99819 9.00334 6.55107 9.00334 5.99953C9.00334 5.44798 9.45045 5.00086 10.002 5.00086Z" />
      </svg>
    </span>
  );
};

export { RegularInfoWarning };
